import { Card, Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import AvisoCard from "../../common/query/AvisoCard";
import { EvaluationScore } from "../../common/query/EvaluationScore";
import ChequesSustados from "../../common/query/ChequesSustados";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ReactApexChart from "react-apexcharts";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import AcoesCiveis from "../../common/query/AcoesCiveis";
import {
  calculateRiskScore,
  formatDocument,
  getLetterScore,
  getScoreLegends,
} from "../../../utils/utils";
import ScoreRating from "./ScoreRating";
import { HiOutlineEye } from "react-icons/hi";
import StreetView from "../../common/query/StreetView";
import { FaRegChartBar, FaUserCheck } from "react-icons/fa";
import { IoReceiptOutline } from "react-icons/io5";
import {
  GrDocumentExcel,
  GrDocumentText,
  GrDocumentTime,
} from "react-icons/gr";
import { CiMoneyCheck1 } from "react-icons/ci";
import { MdOutlineBalance } from "react-icons/md";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { FiUserCheck, FiUsers } from "react-icons/fi";
import CreditQuadrants from "./CreditQuadrants";
import { LuBuilding2 } from "react-icons/lu";
import moment from "moment";

const AcertaEssencialQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = useState(false);
  const [riskScore, setRiskScore] = useState(0);

  const buildDurationLabel = (fromMoment, suffix = "") => {
    if (!fromMoment || !fromMoment.isValid()) return null;
    const years = moment().diff(fromMoment, "years");
    const afterYears = fromMoment.clone().add(years, "years");
    const months = moment().diff(afterYears, "months");
    const parts = [];
    if (years) parts.push(`${years} ano${years === 1 ? "" : "s"}`);
    if (months) parts.push(`${months} mês${months === 1 ? "" : "es"}`);
    if (!parts.length) return `menos de 1 mês${suffix ? ` ${suffix}` : ""}`;
    const joined = parts.join(" e ");
    return suffix ? `${joined} ${suffix}` : joined;
  };

  const cadastro = data?.dadosCadastrais || {};
  const fullAddress = [
    cadastro.endereco,
    cadastro.numero,
    cadastro.bairro,
    cadastro.cidade,
    cadastro.cep,
  ]
    .filter(Boolean)
    .join(", ");
  const birthMoment = cadastro.dataNascimento
    ? moment(cadastro.dataNascimento, ["DD/MM/YYYY", "YYYY-MM-DD"], true)
    : null;
  const birthLabel =
    birthMoment && birthMoment.isValid()
      ? birthMoment.format("DD/MM/YYYY")
      : null;
  const birthDurationLabel = buildDurationLabel(birthMoment, "");

  useEffect(() => {
    setRiskScore(
      calculateRiskScore(
        +data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal || 0,
        +data?.resumoConsulta?.protestos?.quantidadeTotal || 0,
        +data?.score?.score,
        +data?.score?.probabilidade
      )
    );
  }, [data]);

  return (
    <>
      <TitleStripe>
        <div className="flex items-center gap-2">
          <FiUserCheck className="text-blue-700" />{" "}
          <span>Dados Cadastrais</span>
        </div>
      </TitleStripe>

      <div className="text-xs">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
              Nome
            </p>
            <p className="text-lg font-semibold text-gray-900">
              {cadastro.nome || "Indisponível"}
            </p>
          </div>
        </div>

        <div className="mt-2 flex flex-wrap gap-2 text-[10px]">
          {cadastro?.cpf && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              CPF: {formatDocument(cadastro?.cpf)}
            </span>
          )}
          <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
            Situação: {cadastro.situacao || "Desconhecida"}
          </span>
          {birthLabel && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              Data Nasc: {birthLabel}
            </span>
          )}
          {birthDurationLabel && (
            <span className="inline-flex items-center rounded-full border border-gray-200 bg-slate-50 px-2 py-0.5 text-gray-600">
              {birthDurationLabel}
            </span>
          )}
        </div>

        <div className="mt-3 grid gap-2 grid-cols-4">
          {[
            {
              label: "Nome da mãe",
              value: cadastro.nomeMae || "Não informado",
              hint: "Parente",
            },
            {
              label: "Origem CPF",
              value: cadastro.regiaoCPF || "Não informado",
              hint: "Origem",
            },
            {
              label: "Sexo",
              value: cadastro.sexo || "Não informado",
              hint: "Gênero",
            },
            {
              label: "Telefone",
              value: cadastro.telefone || "Não informado",
              hint: "Contato",
            },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-xl border border-gray-200 bg-slate-50 px-3 py-2"
            >
              <p className="text-[10px] uppercase tracking-[0.2em] text-gray-400">
                {item.label}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {item.value}
              </p>
              <p className="text-[10px] text-gray-500">{item.hint}</p>
            </div>
          ))}
        </div>

        <div className="mt-3 rounded-xl border border-gray-200 bg-white px-3 py-2 text-[10px]">
          <p className="font-semibold text-gray-700">Endereço</p>
          <p className="text-sm font-medium text-gray-900">
            {cadastro.endereco || "—"}
            {cadastro.numero && `, ${cadastro.numero}`}
          </p>
          <p className="text-[10px] text-gray-500">
            {cadastro.bairro || "—"} · {cadastro.cidade || "—"}{" "}
            {cadastro.uf ? `/ ${cadastro.uf}` : ""}
          </p>
          {fullAddress && (
            <div
              className="flex items-center gap-1 text-blue-600 cursor-pointer mt-1"
              onClick={() => setOpenMap(true)}
            >
              <span>Ver fotos do local</span>
              <HiOutlineEye className="text-lg" />
            </div>
          )}
        </div>
      </div>

      <div>
        <TitleStripe className="mb-4">
          <div className="flex items-center gap-2">
            <FaRegChartBar className="text-blue-700" />{" "}
            <span>Avaliação preliminar de crédito</span>
          </div>
        </TitleStripe>
      </div>

      <EvaluationScore
        data={data}
        score={data?.score?.score}
        probability={data?.score?.probabilidade}
      />

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}
      <div id="negativacoes-base-1">
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <HiOutlineCurrencyDollar className="text-blue-700" />
            <span>Negativações Registradas</span>
          </div>
        </TitleStripe>

        {data?.pendenciasFinanceiras?.length > 0 ? (
          <>
            <PendenciasFinanceiras
              quantidadeTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
              }
              valorTotal={
                data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
              }
              pendenciasFinanceiras={data?.pendenciasFinanceiras}
            />
          </>
        ) : (
          <NoOcurrence />
        )}

        <div id="protestos-base-1">
          <TitleStripe className="mb-5">
            <div className="flex items-center gap-2">
              <GrDocumentExcel className="text-blue-700" />
              <span>Títulos protestados</span>
            </div>
          </TitleStripe>
          {data?.protestos?.length > 0 ? (
            <Protestos
              quantidadeTotal={data?.resumoConsulta?.protestos?.quantidadeTotal}
              valorTotal={+data?.resumoConsulta?.protestos?.valorTotal}
              protestos={data?.protestos}
              temVencimento={false}
            />
          ) : (
            <NoOcurrence />
          )}
        </div>
      </div>

      {data?.faturasEmAtraso?.nota && (
        <div>
          <TitleStripe className="mb-5">
            <div className="flex items-center gap-2">
              <IoReceiptOutline className="text-blue-700" />
              <span>Faturas em atraso</span>
            </div>
          </TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o máximo de dias que 1 fatura ficou em atraso
            nos últimos 6 meses.
          </div>

          <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "A"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-200`}
              style={{ color: "#1B914E" }}
            >
              A
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "B"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-100`}
              style={{ color: "#73CC37" }}
            >
              B
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "C"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-yellow-100`}
              style={{ color: "#F9C920" }}
            >
              C
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "D"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-orange-100`}
              style={{ color: "#F4771E" }}
            >
              D
            </div>
            <div
              className={`${
                data?.faturasEmAtraso?.nota === "E"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-red-100`}
              style={{ color: "#F23829" }}
            >
              E
            </div>
          </div>
          <div className="mt-2 text-sm">
            Quanto mais próximo o consumidor estiver da faixa{" "}
            <span className="font-semibold">A</span>, menos dias a fatura está
            ou ficou em atraso e quanto mais próximo da faixa{" "}
            <span className="font-semibold">E</span>, mais dias a fatura ficou
            em atraso.
          </div>
        </div>
      )}

      {data?.contratosRecentes?.nota && (
        <div>
          <TitleStripe className="mb-5">
            <div className="flex items-center gap-2">
              <GrDocumentText className="text-blue-700" />
              <span>Contratos recentes</span>
            </div>
          </TitleStripe>
          <div className="-mt-2 mb-2 text-sm">
            Indica uma nota para o nível de comprometimento de crédito do
            consumidor, com base na quantidade de contratos fechados nos últimos
            6 meses.
          </div>

          <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
            <div
              className={`${
                data?.contratosRecentes?.nota === "A"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-200`}
              style={{ color: "#1B914E" }}
            >
              A
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "B"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-green-100`}
              style={{ color: "#73CC37" }}
            >
              B
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "C"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-yellow-100`}
              style={{ color: "#F9C920" }}
            >
              C
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "D"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-orange-100`}
              style={{ color: "#F4771E" }}
            >
              D
            </div>
            <div
              className={`${
                data?.contratosRecentes?.nota === "E"
                  ? "border-4 border-blue-500"
                  : "border-gray-300 border"
              } p-2 text-center font-bold text-lg bg-red-100`}
              style={{ color: "#F23829" }}
            >
              E
            </div>
          </div>
          <div className="mt-2 text-sm">
            Quanto mais próximo da faixa{" "}
            <span className="font-semibold">A</span>, menos contratos foram
            fechados e quanto mais perto da faixa{" "}
            <span className="font-semibold">E</span>, mais contratos foram
            fechados nos últimos 6 meses.
          </div>
        </div>
      )}

      <div id="ccs-base-1">
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <CiMoneyCheck1 className="text-blue-700" />
            <span>Cheques sustados</span>
          </div>
        </TitleStripe>

        {data?.chequesSustados?.length > 0 ? (
          <>
            <ChequesSustados chequesSustados={data?.chequesSustados} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <div id="ccf-base-1">
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <CiMoneyCheck1 className="text-blue-700" />
            <span>Cheques sem fundo</span>
          </div>
        </TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <MdOutlineBalance className="text-blue-700" />
            <span>Ações Cíveis</span>
          </div>
        </TitleStripe>
        {data?.acoesCiveis?.length > 0 ? (
          <AcoesCiveis
            quantidadeTotal={data?.resumoConsulta?.acoesCiveis?.quantidadeTotal}
            acoesCiveis={data?.acoesCiveis}
          />
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">
          <div className="flex items-center gap-2">
            <GrDocumentTime className="text-blue-700" />
            <span>Histórico de consultas</span>
          </div>
        </TitleStripe>

        {data?.historicoConsultas?.length > 0 ? (
          <div className="flex gap-2 items-start">
            <div className="flex-1">
              <HistoricoConsultas
                quantidadeTotal={data?.historicoConsultas?.length}
                historicoConsultas={data?.historicoConsultas}
              />
            </div>
            {/* {data?.historicoConsultasResumo?.paresMesAnoHistoricoConsultas
              ?.length > 0 && (
              <ReactApexChart
                className="border border-gray-200 rounded-md w-2/5 mt-3"
                options={{
                  colors: ["var(--primary)"],
                  chart: {
                    height: 150,
                    type: "bar",
                    toolbar: {
                      show: false, // Remove o menu de ações
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 2,
                      dataLabels: {
                        position: "center", // top, center, bottom
                      },
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return val;
                    },
                    offsetY: 0,
                    style: {
                      fontSize: "12px",
                      colors: ["white"],
                    },
                  },

                  xaxis: {
                    categories:
                      data?.historicoConsultasResumo
                        ?.paresMesAnoHistoricoConsultas,
                    position: "top",
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    crosshairs: {
                      fill: {
                        type: "gradient",
                        gradient: {
                          colorFrom: "#30ce2d",
                          colorTo: "#30ce2d",
                          stops: [0, 100],
                          opacityFrom: 0.4,
                          opacityTo: 0.5,
                        },
                      },
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  yaxis: {
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      show: false,
                      formatter: function (val) {
                        return val;
                      },
                    },
                  },
                  title: {
                    text: "Últimos 90 dias",
                    floating: true,
                    offsetY: 155,
                    align: "center",
                    style: {
                      color: "#444",
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. Consultas no período",
                    data: data?.historicoConsultasResumo
                      ?.totaisHistoricoConsultas,
                  },
                ]}
                type="bar"
                height={175}
              />
            )} */}
          </div>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AcertaEssencialQuery;
